import './crfGrouping.css';

import { memo, useCallback, useEffect, useState } from "react";
import CrfTable from "./crfTable";
import NoResults from '../Layouts/ResultsTable/noResults';

const CrfGrouping = ({ results, diseaseId }) => {
    const [isExpanded, setIsExpanded] = useState([]);
    const [allExpanded, setAllExpanded] = useState(false);

    useEffect(() => {
        // construct isExpanded
        const newIsExpanded = [];

        results.forEach(domain => domain.subDomainGroups.forEach(subDomain => {
            if (!newIsExpanded.some(exp => exp.key === `${domain.domainId}_${subDomain.subDomainId}`))
                newIsExpanded.push({ key: `${domain.domainId}_${subDomain.subDomainId}`, value: false });
        }));

        setIsExpanded(newIsExpanded);
    }, [results]);

    const toggleAllExpandedHandler = useCallback(() => {
        setAllExpanded(prevAll => {
            const newIsExpanded = [...isExpanded];
            newIsExpanded.forEach(exp => exp.value = !prevAll);

            setIsExpanded(newIsExpanded);

            return !prevAll;
        });
    }, [isExpanded]);

    const toggleExpandedHandler = useCallback(key => {
        const entry = isExpanded.find(exp => exp.key === key);
        entry.value = !entry.value;

        setIsExpanded([entry, ...isExpanded]);
    }, [isExpanded]);

    const getIsExpanded = useCallback(key => isExpanded?.find(exp => exp.key === key)?.value ?? false, [isExpanded]);

    if (!results.length)
        return <NoResults />;

    return (
        <>
            <button className="expand-all" onClick={e => toggleAllExpandedHandler(e)}>{allExpanded ? 'Collapse All' : 'Expand All'}</button>
            {results.map(domain => (
                <div key={domain.domainId} className="view-grouping">
                    <div className="view-grouping-header">{domain.domainName}</div>
                    <div className="view-grouping-content">
                        {domain.subDomainGroups.map(subDomain => {
                            const expanded = getIsExpanded(`${domain.domainId}_${subDomain.subDomainId}`);

                            return <CrfTable
                                key={`${domain.domainId}_${subDomain.subDomainId}`}
                                domain={domain}
                                subDomain={subDomain}
                                crfs={subDomain.crfs}
                                isExpanded={expanded}
                                toggleExpanded={toggleExpandedHandler}
                                diseaseId={diseaseId}
                            />
                        })}
                    </div>
                </div>
            ))}
        </>
    );
}

export default memo(CrfGrouping);